module.exports = __webpack_public_path__ + "static/media/item_2_2_comp.b5133b32.png";